<template>
  <app-custom-dialog
    v-model="open"
    :title="current ? localized(current.title) : ''"
    :is_translate="false"
    :title-icon="current && current.type === 'feature' ? 'fal fa-sparkles' : 'fal fa-bullhorn'"
    :show-cancel="false"
    submit-text="announcement_got_it"
    width="520px"
    @submit="next"
    @cancel="next"
  >
    <div v-if="current" slot="activator">
      <v-chip small label class="mb-3" :color="current.type === 'feature' ? 'primary' : 'blue-grey'" dark>
        {{ $t(`announcement_type_${current.type}`) }}
      </v-chip>
      <div class="announcement-body">{{ localized(current.description) }}</div>
      <div v-if="current.starts_at" class="text-caption grey--text mt-4">
        {{ current.starts_at | moment }}
      </div>
    </div>
  </app-custom-dialog>
</template>

<script>
import { myMixin } from "@/mixin/main";

const STORAGE_KEY = "announcements_shown";
const CHECKED_KEY = "announcements_checked";

const readShown = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
  } catch (_) {
    return [];
  }
};

const isChecked = () => {
  try {
    return sessionStorage.getItem(CHECKED_KEY) === "1";
  } catch (_) {
    return false;
  }
};

const markChecked = () => {
  try {
    sessionStorage.setItem(CHECKED_KEY, "1");
  } catch (_) {
    /* storage unavailable */
  }
};

export default {
  name: "AnnouncementPopup",
  mixins: [myMixin],
  data: () => ({
    queue: [],
    open: false,
  }),
  computed: {
    current() {
      return this.queue[0] || null;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    localized(map) {
      if (!map) return "";
      return map[this.$i18n.locale] || map.en || map.la || Object.values(map)[0] || "";
    },
    async load() {
      // set once everything was shown (or nothing to show) so navigation does not refetch;
      // login clears it so "every_login" announcements come back
      if (isChecked()) return;
      try {
        const { data } = await this.$http.get("announcements/active");
        if (!data.status) return;
        // announcements already shown during this login session are skipped,
        // so navigating or refreshing does not re-open them
        const shown = readShown();
        this.queue = data.data.filter((a) => !shown.includes(a.id));
        this.open = this.queue.length > 0;
        if (!this.open) markChecked();
      } catch (_) {
        // an announcement failure must never block the POS
      }
    },
    async next() {
      const item = this.queue[0];
      if (!item) return;
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...readShown(), item.id]));
      } catch (_) {
        /* storage unavailable: fall back to server-side frequency only */
      }
      this.$http
        .post(`announcements/${item.id}/seen`)
        .then(() => this.$root.$emit("announcements-updated"))
        .catch(() => {});
      this.queue = this.queue.slice(1);
      this.open = false;
      if (this.queue.length) {
        await this.$nextTick();
        this.open = true;
      } else {
        markChecked();
      }
    },
  },
};
</script>

<style scoped>
.announcement-body {
  white-space: pre-line;
  line-height: 1.6;
}
</style>
